export default __webpack_public_path__ + "b19c9009a37570a1efe65972d47d72b9.ico";